import type { BadgePropStatus } from 'uikit';
import { Badge } from 'uikit';

import * as React from 'react';

export const methodologyCellProps: Record<string, { label: string; status?: BadgePropStatus }> = {
    UER: { label: 'УЕР' },
    BIM: { label: 'БИМ', status: 'warning' },
    ETR: { label: 'ЕТР' },
    NONE: { label: 'Отсутствует' },
};

export const ProjectMethodology = ({ methodology, className }: { methodology: string; className?: string }) => (
    <Badge view="stroked" {...methodologyCellProps[methodology]} className={className} />
);

ProjectMethodology.displayName = 'ProjectMethodology';
